import { TER01_01 } from "./TER01_01";

export const TER01 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 2,
    type: "stacked",
    colorTheme: "colorTheme1",
    title: "Stocks Trend Based On Number Of Branches Covered",
    orientation: "horizontal",
    xAxis: "Totals",
    yAxis: "Items",
    binding: {
      data: {
        series: [
          {
            name: "OOS",
            value: "OutOfStock",
          },
          {
            name: "Not Carried",
            value: "NotCarried",
          },
          {
            name: "Carried",
            value: "Carried",
          },
          {
            name: "For Deletion",
            value: "ForDeletion",
          },
          {
            name: "Deleted",
            value: "Deleted",
          },
        ],
        title: "ItemName",
        endpoint: "TER01",
        parameters: [
          { key: "FromMonth", value: "CP1" },
          { key: "FromYear", value: "2026" },
          { key: "ToMonth", value: "CP1" },
          { key: "ToYear", value: "2026" },
          { key: "TradeTeamCode", value: "" },
        ],
      },
      context: {
        point: {
          onClick: TER01_01,
        },
      },
    },
  },
};
